import { useTranslation } from "react-i18next";
import { useUncontrolledState } from "@tellescope/ui";
import { AttachDialogShell } from "./AttachDialogShell";
import { FilesVariantContent } from "./FilesVariantContent";
import { useFilesVariant } from "./useFilesVariant";
import type { AttachFileDialogFilesProps } from "./types";

export const FilesAttachDialog = ({
  children,
  enduserId,
  open,
  onOpenChange,
  onAttachExisting,
  onUploadNew,
  selectedSecureNames = [],
  channelType = "chat",
}: AttachFileDialogFilesProps) => {
  const { t } = useTranslation("inbox");
  const [dialogOpen, setDialogOpen] = useUncontrolledState<boolean>({
    state: open ?? false,
    setState: onOpenChange
      ? (value) => onOpenChange(value instanceof Function ? value(open ?? false) : value)
      : undefined,
  });
  const logic = useFilesVariant({
    enduserId,
    channelType,
    selectedSecureNames,
    dialogOpen,
    onAttachExisting,
    onUploadNew,
  });

  const closeDialog = (newOpen: boolean) => {
    if (!newOpen) {
      logic.reset();
    }
    setDialogOpen(newOpen);
  };

  const handleAttach = async () => {
    await logic.attach();
    closeDialog(false);
  };

  return (
    <AttachDialogShell
      trigger={children}
      title={t("Select Files")}
      description={t("Choose files to attach")}
      open={dialogOpen}
      onOpenChange={closeDialog}
      selectedCount={logic.totalSelectedCount}
      onAttach={handleAttach}
      onCancel={() => closeDialog(false)}
      confirmTrackingId="attach-files-confirm"
    >
      <FilesVariantContent logic={logic} />
    </AttachDialogShell>
  );
};
